import { Link } from "react-router-dom";
import { STATUS } from "@/data/evidence";

// Inline evidence mark — gold-only, typographic. ◆ Proven · ◇ Validation · · Frontier.
// Lives inside prose so a claim carries its status where it is made.
const GLYPH = { PROVEN: "◆", VALIDATION: "◇", FRONTIER: "·" };

export const EvidenceMark = ({ status = "FRONTIER", to, children, testId, className = "" }) => {
  const s = STATUS[status] || STATUS.FRONTIER;
  const body = (
    <>
      <span aria-hidden="true" className={`evidence-glyph ${status === "FRONTIER" ? "text-[1.1em] leading-none" : "text-[0.7em]"}`}>{GLYPH[s.id]}</span>
      <span className="evidence-word">{children || s.label}</span>
      <span role="tooltip" className="evidence-tip">{s.label} — {s.summary}</span>
    </>
  );
  const cls = `evidence-mark group relative inline-flex items-baseline gap-1.5 font-mono-spec text-[0.56rem] tracking-[0.24em] text-[#84DFF4] ${className}`;
  return to ? (
    <Link to={to} data-testid={testId || `evidence-${s.id.toLowerCase()}`} data-status={s.id} className={cls} aria-label={`${s.label}: ${s.summary}`}>{body}</Link>
  ) : (
    <span data-testid={testId || `evidence-${s.id.toLowerCase()}`} data-status={s.id} tabIndex={0} className={cls} aria-label={`${s.label}: ${s.summary}`}>{body}</span>
  );
};

export const EvidenceKey = ({ testId = "evidence-key" }) => (
  <p data-testid={testId} className="flex flex-wrap items-center gap-x-8 gap-y-3">
    {Object.keys(STATUS).map((id) => <EvidenceMark key={id} status={id} testId={`${testId}-${id.toLowerCase()}`} />)}
  </p>
);
